import { LocaleSeo } from 'groq/shared/LocaleSeo';
import { LocaleString } from 'groq/shared/LocaleString';
import { LocaleTag } from 'groq/shared/LocaleTag';
import { SanityVideoObject } from 'groq/objects/SanityVideoObject';
import { LocalePortableText } from 'groq/shared/LocalePortableText';
import { SanityImageObject } from 'groq/objects/SanityImageObject';
import {
  GlossaryPage,
  GlossaryPageProps,
} from 'ui/pages/GlossaryPage/GlossaryPage';
import { useGroqQuery } from 'hooks/useGroqQuery';

declare module 'groq/GroqOperationNames' {
  interface GroqOperationNames {
    GlossaryPage: GlossaryPageProps['page'];
    GlossaryTerms: GlossaryPageProps['terms'];
  }
}
function useGlossaryPageQuery() {
  return useGroqQuery({
    operationName: 'GlossaryPage',
    query: `
      *[_type == "GlossaryPage" && country == upper($country)][0] {
        "header": {
          ${SanityImageObject('headerBackgroundImage')},
          ${LocaleString('headerTitle')},
          ${LocaleString('headerIntroduction')},
        },
        ${LocaleSeo('seo')},
      }
    `,
  });
}

function useGlossaryTermsQuery() {
  return useGroqQuery({
    operationName: 'GlossaryTerms',
    query: `
      *[_type == "GlossaryTerm"] {
        "puid": puid.current,
        ${LocaleTag('tags[]->')},
        ${LocaleString('term')},
        ${LocalePortableText('definition')},
        ${SanityImageObject('image')},
        ${SanityVideoObject('video')},
      }
    `,
  });
}

export default function Glossary() {
  const [glossaryPage] = useGlossaryPageQuery();
  const [glossaryTerms] = useGlossaryTermsQuery();

  const page = glossaryPage?.data?.content;
  const terms = glossaryTerms?.data?.content;

  return page && terms ? <GlossaryPage page={page} terms={terms} /> : null;
}
